import service from '../../utils/request'


const getVerificationCode = (data) => {
    return service({
        url: 'api/getVerificationCode',
        method: 'post',
        data
    })
}
const loginPwd = (data) => {
    return service({
        url: 'api/enrollByNaPwd',
        method: 'post',
        data
    })
}
const loginCode = (data) => {
    return service({
        url: 'api/enrollByNaCode',
        method: 'post',
        data
    })
}

const register = (data) => {
    return service({
        url: 'api/registerUser',
        method: 'post',
        data
    })
}
const resetPwd = (data) => {
    return service({
        url: 'api/resetPwd',
        method: 'post',
        data
    })
}
const ifLogin = (data) => {
    return service({
        url: 'api/ifLogin',
        method: 'post',
        data
    })
}

export {
    getVerificationCode,
    loginPwd,
    loginCode,
    register,
    resetPwd,
    ifLogin
}